import styled from "styled-components";
import { Upload as AntdUpload } from "antd";

export const UploadLabelWrapper = styled.div`
  margin-top: 0.5rem;
`;

export const PreviewImage = styled.img`
  width: 100%;
`;

export const Upload = styled(AntdUpload)`
  .ant-upload-select,
  .ant-upload-list-item-container {
    width: 100% !important;
  }
`;
